import OrderListPage from './views/OrderListPage.vue';
import OrderDetailPage from './views/OrderDetailPage.vue';
import OrderTrackingPage from './views/OrderTrackingPage.vue';
import CheckoutPage from './views/CheckoutPage.vue';

export default [
  {
    path: '/orders',
    name: 'orders',
    component: OrderListPage,
    meta: {
      title: 'Mes Commandes',
      headerVisible: true,
      headerColor: '#ffffff',
      requiresAuth: true
    }
  },
  {
    path: '/orders/:id',
    name: 'order-detail',
    component: OrderDetailPage,
    meta: {
      title: 'Détail de la commande',
      headerVisible: true,
      headerColor: '#ffffff',
      requiresAuth: true
    }
  },
  {
    path: '/orders/:id/tracking',
    name: 'order-tracking',
    component: OrderTrackingPage,
    meta: {
      title: 'Suivi de livraison',
      headerVisible: false,
      requiresAuth: true
    }
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutPage,
    meta: {
      title: 'Finaliser la commande',
      headerVisible: true,
      headerColor: '#ffffff',
      requiresAuth: true
    }
  }
];
